import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <div className="footer__brand">
            <div className="footer__logo">
              <span>GYM</span><span className="orange">ARENAA</span>
            </div>
            <p className="footer__tagline">
              Where Champions Are Built.
            </p>
            <p className="footer__copy">© {new Date().getFullYear()} Gym Arenaa. All rights reserved.</p>
          </div>

          <div className="footer__links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#hero">Home</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#equipment">Equipment</a></li>
              <li><a href="#reviews">Reviews</a></li>
              <li><a href="#location">Location</a></li>
            </ul>
          </div>

          <div className="footer__contact">
            <h4>Contact</h4>
            <p>gymarenaa163@gmail.com</p>
            <p>+91 9022554999</p>
            <p>2nd Floor, NMS Titanium, Dausha Ram Mahatrey Marg, near McDonalds, Sector 15, CBD Belapur, Navi Mumbai, Maharashtra 400614</p>
          </div>
        </div>
      </div>
    </footer>
  );
}